
/*
Este modulo contendrá configuración del sistema.
*/
angular.module('Config', [])
    .config([
        '$logProvider', function($logProvider) {
            $logProvider.debugEnabled(false);
        }
    ]);